import React, { useEffect, useRef } from 'react';
import { motion } from 'framer-motion';
import { gsap } from 'gsap';
import { FaArrowRight, FaCheckCircle, FaShieldAlt, FaClock, FaLock } from 'react-icons/fa';

const SectionHero = () => {
  const heroRef = useRef(null);
  const floatingRef = useRef(null);

  useEffect(() => {
    // GSAP animations for hero elements
    const tl = gsap.timeline();
    
    tl.fromTo(
      '.hero-title',
      { y: 60, opacity: 0 },
      { y: 0, opacity: 1, duration: 1, ease: 'power3.out' }
    )
    .fromTo(
      '.hero-subtitle',
      { y: 40, opacity: 0 },
      { y: 0, opacity: 1, duration: 0.8, ease: 'power3.out' },
      '-=0.6'
    )
    .fromTo(
      '.hero-cta',
      { y: 30, opacity: 0 },
      { y: 0, opacity: 1, duration: 0.6, ease: 'power3.out' },
      '-=0.4'
    )
    .fromTo(
      '.hero-features',
      { y: 20, opacity: 0 },
      { y: 0, opacity: 1, duration: 0.6, ease: 'power3.out' },
      '-=0.3'
    );

    // Floating animation for the illustration
    gsap.to(floatingRef.current, {
      y: -15,
      duration: 2,
      repeat: -1,
      yoyo: true,
      ease: 'power1.inOut'
    });
  }, []);

  const features = [
    { icon: FaClock, text: '100% Online' },
    { icon: FaLock, text: 'Secure Application' },
    { icon: FaShieldAlt, text: 'Responsible Lending' },
  ];

  return (
    <section ref={heroRef} className="relative min-h-[90vh] flex items-center bg-mesh overflow-hidden">
      {/* Background decorations */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-20 right-0 w-96 h-96 bg-gradient-to-br from-secondary/20 to-transparent rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 left-0 w-80 h-80 bg-gradient-to-tr from-primary/10 to-transparent rounded-full blur-3xl"></div>
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-gradient-radial from-secondary/5 to-transparent rounded-full"></div>
      </div>

      <div className="container mx-auto px-4 lg:px-8 py-20 relative z-10">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-8 items-center">
          {/* Left Content */}
          <div className="max-w-xl">
            <motion.div
              initial={{ opacity: 0, scale: 0.9 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.5 }}
              className="inline-flex items-center gap-2 bg-primary/10 text-primary px-4 py-2 rounded-full mb-6"
            >
              <FaCheckCircle className="text-secondary" />
              <span className="text-sm font-medium">Trusted Australian Lender</span>
            </motion.div>

            <h1 className="hero-title font-display text-4xl md:text-5xl lg:text-6xl font-bold text-dark leading-tight mb-6">
              Fast & Simple Loans –{' '}
              <span className="text-gradient">Anytime You Need</span>{' '}
              <span className="relative inline-block">
                Cash.
                <svg className="absolute -bottom-2 left-0 w-full" viewBox="0 0 200 12" fill="none">
                  <path d="M2 10C50 2 150 2 198 10" stroke="#fdd41e" strokeWidth="4" strokeLinecap="round"/>
                </svg>
              </span>
            </h1>

            <p className="hero-subtitle text-lg md:text-xl text-gray-600 mb-8 leading-relaxed">
              Trusted Australian lender. Quick online approval. No hidden fees. Get the financial support you need today.
            </p>

            <div className="hero-cta flex flex-wrap gap-4 mb-10">
              <a
                href="/apply-now"
                className="group bg-primary hover:bg-primary-700 text-white font-semibold py-4 px-8 rounded-full transition-all duration-300 hover:shadow-xl hover:shadow-primary/30 flex items-center gap-2"
              >
                Apply Now
                <FaArrowRight className="group-hover:translate-x-1 transition-transform" />
              </a>
              {/* <a
                href="/costs"
                className="bg-white hover:bg-gray-50 text-primary font-semibold py-4 px-8 rounded-full border-2 border-primary/20 hover:border-primary/40 transition-all duration-300 flex items-center gap-2"
              >
                Check Eligibility
              </a> */}
            </div>

            <div className="hero-features flex flex-wrap gap-6 text-sm text-gray-600">
              {features.map((feature, index) => (
                <div key={index} className="flex items-center gap-2">
                  <feature.icon className="text-primary" />
                  <span>{feature.text}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Right Content - Floating Illustration */}
          <div ref={floatingRef} className="relative lg:pl-8">
            <div className="relative">
              {/* Main card */}
              {/* <div className="glass-card md:p-10 bg-transparent"> */}
                <div className="flex items-center">
                  <img src="/hero_image.webp" alt="" className="inset-0 w-full h-full object-cover"></img>
{/*                   <div className="w-16 h-16 bg-gradient-to-br from-primary to-primary-600 rounded-2xl flex items-center justify-center shadow-lg">
                    <span className="text-3xl text-secondary font-bold">$</span>
                  </div> */}
                  <div>
{/*                     <h3 className="font-display font-bold text-xl text-dark">Quick Cash</h3>
                    <p className="text-gray-500 text-sm">Same day approval</p> */}
                  </div>
                {/* </div> */}

                {/* Loan Amount Display */}
{/*                 <div className="bg-gradient-to-br from-primary/5 to-secondary/5 rounded-2xl p-6 mb-6">
                  <p className="text-sm text-gray-500 mb-2">Loan Amount</p>
                  <p className="text-4xl font-display font-bold text-primary">$2,500</p>
                  <div className="mt-4 h-2 bg-gray-200 rounded-full overflow-hidden">
                    <div className="h-full w-3/4 bg-gradient-to-r from-primary to-secondary rounded-full"></div>
                  </div>
                  <div className="flex justify-between mt-2 text-xs text-gray-400">
                    <span>$500</span>
                    <span>$5,000</span>
                  </div>
                </div> */}

                {/* Stats */}
{/*                 <div className="grid grid-cols-2 gap-4">
                  <div className="text-center p-4 bg-white rounded-xl shadow-sm">
                    <p className="text-2xl font-bold text-primary">24h</p>
                    <p className="text-xs text-gray-500">Fast Approval</p>
                  </div>
                  <div className="text-center p-4 bg-white rounded-xl shadow-sm">
                    <p className="text-2xl font-bold text-secondary-600">0%</p>
                    <p className="text-xs text-gray-500">Hidden Fees</p>
                  </div>
                </div> */}
              </div>

              {/* Floating badge */}
{/*               <motion.div
                animate={{ y: [0, -10, 0] }}
                transition={{ duration: 3, repeat: Infinity, ease: 'easeInOut' }}
                className="absolute -top-4 -right-4 bg-secondary text-primary-800 px-4 py-2 rounded-full font-semibold text-sm shadow-lg"
              >
                ✨ Fast & Easy
              </motion.div> */}

              {/* Floating dollar signs */}
{/*               <motion.div
                animate={{ y: [0, -20, 0], rotate: [0, 10, 0] }}
                transition={{ duration: 4, repeat: Infinity, ease: 'easeInOut' }}
                className="absolute -bottom-6 -left-6 w-16 h-16 bg-primary rounded-2xl flex items-center justify-center shadow-xl"
              >
                <span className="text-2xl text-secondary">$</span>
              </motion.div> */}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SectionHero;
